import * as moment from "moment";
import { TallyConfig } from "../helpers/constants";
import { xmlToJs } from "../helpers/xmltojs";
import axios from "axios";
import { SyncLedgers } from "./ledgers";
import { SyncStockItems } from "./items";
import { userSignal } from "../../../../signal/userSignal";

export async function SyncOutStandings(ledgers) {
    try {

        if (!ledgers) {
            console.log("Ledgers not found")
            return false
        }

        ledgers = ledgers?.ENVELOPE?.BODY?.DATA?.COLLECTION?.LEDGER || []

        if (!(ledgers instanceof Array)) {
            ledgers = [ledgers]
        }

        if (ledgers.length === 0) {
            return true
        }

        let data = []

        for (let i = 0; i < ledgers.length; i++) {
            let ledger = ledgers[i]
            let dealer = {
                name: ledger?._attributes?.NAME,
            }

            dealer.tallyDetails = [{
                masterId: ledger?.MASTERID?._text || "",
                guId: ledger?.GUID?._text || "",
                companyName: TallyConfig.company || "",
                alterId: ledger?.ALTERID?._text || "",
            }]
            let outstanding = ledger?.CLOSINGBALANCE?._text || 0
            outstanding = parseFloat(outstanding)

            if (outstanding !== 0) {
                dealer.tallyDetails[0].outstanding = outstanding
            }

            data.push(dealer)
        }

        let resp = await window.electron.grpcConnect({
            userId: userSignal?.value?.user.id,
            organisationId: userSignal?.value?.user?.organisation,
            reqType: "syncOutStandings",
            dealers: JSON.stringify(data),
        })

        // wait for 2s
        await new Promise((resolve, reject) => {
            setTimeout(async () => {
                resolve()
            }, 5000)
        })

        return
    } catch (err) {
        console.log(err)
        return false
    }

}

export async function SyncAccStatment(ledger, html, company){
    try{

        let accStatements = {}
        accStatements[company] = html

        let data = {
            dealerId: ledger?.id,
            organisation: ledger?.organisation,
            name: ledger?.name,
            accStatements: accStatements
        }

        let resp = await window.electron.grpcConnect({
            userId: userSignal?.value?.user.id,
            organisationId: userSignal?.value?.user?.organisation,
            reqType: "syncAccStatement",
            dealers: JSON.stringify(data),
        })

        // wait for 2s
        await new Promise((resolve, reject) => {
            setTimeout(async () => {
                resolve()
            }, 5000)
        })
    }catch(err){
        console.log(err)
        return false
    }
}

export async function SyncStockSummary(stockItems) {

    try {
        if (!stockItems) {
            console.log("No stock items found")
            return false
        }

        stockItems = stockItems?.ENVELOPE?.BODY?.DATA?.COLLECTION?.STOCKITEM || []

        if(!(stockItems instanceof Array)){
            stockItems = [stockItems]
        }

        if (stockItems.length === 0) {
            return true
        }
        
        let products = []

        stockItems.forEach(stockItem => {
            let product = {
                name: stockItem?._attributes?.NAME,
                tallyId: stockItem?.MASTERID?._text,
            }

            let balance = stockItem?.CLOSINGBALANCE?._text || 0
            balance = parseFloat(balance)

            product.tallyQty = balance

            products.push(product)
        })

        let resp = await window.electron.grpcConnect({
            userId: userSignal?.value?.user.id,
            organisationId: userSignal?.value?.user?.organisation,
            reqType: "syncStocks",
            products: JSON.stringify(products),
        })

        // wait for 2s
        await new Promise((resolve, reject) => {
            setTimeout(async () => {
                resolve()
            }, 5000)
        })

    } catch (err) {
        console.log(err)
        return false
    }

}
